

export interface PaymentOperationResult {
    success:boolean,
    paymentOperationStatus?: PaymentOperationStatus,
    paymentStatus?:PaymentStatus,
    transactionId?:string,
    // providerTransactionId?:string,
    paymentLink?:string,
    ongoing?:boolean,
    transactionSuccess?:boolean,
    error?:string
}

export enum PaymentOperationStatus {
    TRANSACTION_CREATED="TRANSACTION_CREATED",
    TRANSACTION_FOUND="TRANSACTION_FOUND",
    TRANSACTION_NOT_FOUND="TRANSACTION_NOT_FOUND",
    USER_HAS_NO_PAYMENT_PROFILE="USER_HAS_NO_PAYMENT_PROFILE",
    NO_BILLING_DETAILS_FOUND_FOR_PRODUCT="NO_BILLING_DETAILS_FOUND_FOR_PRODUCT_AND_PROVIDER",

    PAYMENT_PROFILE_CREATED="PAYMENT_PROFILE_CREATED",
    INVALID_DATA="INVALID_DATA",

    PAYMENT_PROVIDER_OVERLOADED="PAYMENT_PROVIDER_OVERLOADED",
    GENERIC_ERROR="GENERIC_ERROR"
}

export enum PaymentStatus {
    PENDING="PENDING",
    RECEIVED="RECEIVED",
    CONFIRMED="CONFIRMED",
    OVERDUE="OVERDUE",
    REFUNDED="REFUNDED",
    RECEIVED_IN_CASH="RECEIVED_IN_CASH",
    REFUND_REQUESTED="REFUND_REQUESTED",
    REFUND_IN_PROGRESS="REFUND_IN_PROGRESS",
    CHARGEBACK_REQUESTED="CHARGEBACK_REQUESTED",
    CHARGEBACK_DISPUTE="CHARGEBACK_DISPUTE",
    AWAITING_CHARGEBACK_REVERSAL="AWAITING_CHARGEBACK_REVERSAL",
    DUNNING_REQUESTED="DUNNING_REQUESTED",
    DUNNING_RECEIVED="DUNNING_RECEIVED",
    AWAITING_RISK_ANALYSIS="AWAITING_RISK_ANALYSIS",
}

//-------------------------
//------ ERROR TYPES
//-------------------------

enum ProviderErrorTypes{
    INVALID_DATA="invalid data",
    PROVIDER_OVERLOADED="provider overloaded",
    INVALID_REQUEST_DATA="bad/invalid request",
    UNAUTHORIZED="unauthorized",
    COMMUNICATION_ERROR="communication error"
}

export class PaymentProviderError extends Error{
    protected type?:ProviderErrorTypes;
    private details?:string;
    private url?:string;
    private jsonBody?:any;
    private httpErrorCode?:number;
    private canRetry:boolean=false;

    constructor(props?:{
        errorDetails?:string,
        apiUrl?:string,
        jsonBody?:any,
        httpErrorCode?:number
    }){
        super('fallback-error-msg'); //Default message (fallback)

        this.details = props?.errorDetails;
        this.url = props?.apiUrl;
        this.jsonBody = props?.jsonBody;
        this.httpErrorCode = props?.httpErrorCode;
        
        //Type interpretation
        if(this.httpErrorCode){
            if(this.httpErrorCode===400){this.type=ProviderErrorTypes.INVALID_DATA;}
            if(this.httpErrorCode===401){this.type=ProviderErrorTypes.UNAUTHORIZED;}
            if(this.httpErrorCode===429){
                this.type=ProviderErrorTypes.PROVIDER_OVERLOADED;
                this.canRetry=true;
            }
            if(this.httpErrorCode===999){
                this.type=ProviderErrorTypes.COMMUNICATION_ERROR;
                this.canRetry=true;
            }
            if(this.httpErrorCode>500){
                this.canRetry=true;
            }
        }

        this.message = this.getLogString();
        Object.setPrototypeOf(this, new.target.prototype); // Fix prototype chain
    }

    public getLogString(){
        const detailsString = this.details?`details => [${this.details}]`:'';
        const urlString = this.url?`endpoint => [${this.url}]`:'';
        const jsonBody = this.jsonBody?`body => [${this.jsonBody}]`:'';
        const httpErrorCode = this.httpErrorCode?`http error => [${this.httpErrorCode}]`:'';

        return `[${this.type}] => ${urlString} ${httpErrorCode} ${jsonBody} ${detailsString}`;
    }

    public retry(): boolean {
        return this.canRetry;
    }
}
export interface ProviderConfig {
    id:string,
    name:string,
    config:any,
    production:boolean,
}